import { API_BASE, API_BASE_V2, CLIENT_ID, CLIENT_SECRET, initHeaders, METHOD } from './constans'
import { setToken } from '../redux/actions/user.action'
import { userLogout } from '../redux/actions/auth'
import { getUserTimeZone } from '../helpers/time-helper/time-helper'
import Cookies from 'js-cookie'
import { logDOM } from '@testing-library/react'
import Boolean from 'yup/lib/boolean'

export const getToken = () => {
  return JSON.parse(localStorage.getItem('user'))
}

export const customHeaders = {
  'X-User-Time-Zone': getUserTimeZone(),
  'X-User-Agent': 'web',
}

let refreshPromise = null

export const getRefreshToken = async (refreshToken) => {
  try {
    const response = await fetch(`${API_BASE_V2}token/`, {
      method: METHOD.POST,
      headers: initHeaders,
      body: JSON.stringify({
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
        scope: 'company',
      }),
    })
    const data = await response.json().catch(() => null)

    if (response.status === 400) {
      return { ok: false, error: 'Refresh token invalid' }
    }

    if (!response.ok) {
      console.error('❌ Ошибка обновления токена. Код:', response.status)
      return { ok: false, error: `Ошибка ${response.status}` }
    }

    if (!data || !data.access_token) {
      console.error('❌ Сервер не вернул `access_token`!', data)
      return { ok: false, error: 'Сервер не вернул access_token' }
    }

    return { ...data, ok: true }
  } catch (error) {
    console.error('❌ Ошибка при обновлении токена:', error)
    return { ok: false, error: 'Ошибка запроса к API' }
  }
}

// check function is valid token
export const isExpired = (exp) => {
  if (!exp) {
    return false
  }

  return Date.now() > exp
}

export async function authPostFormData(url, data = {}) {
  const token = JSON.parse(localStorage.getItem('user'))
  if (token) {
    const response = await fetch(API_BASE + url, {
      method: 'POST',
      headers: {
        ...customHeaders,
        Authorization: `Bearer ${token.access_token}`,
      },
      body: data,
    })
    const result = await response.json()

    result.ok = response.ok
    return result
  }
}

export const request = async (endpoint, options = {}) => {
  const domain = options.api || API_BASE
  let token = typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('user')) || null : null

  const headers = {
    ...initHeaders,
    ...options?.headers,
  }

  if (options.body instanceof FormData) {
    delete headers['Content-Type']
  }

  if (token && !options.withoutToken) {
    headers['Authorization'] = `Bearer ${token.access_token}`
  }

  const init = {
    method: options.method || METHOD.GET,
    body: options.body,
    headers: headers,
  }

  try {
    let response = await fetch(`${domain}${endpoint}`, init)
    

    // 401 без токена — уже вылогинены, но остались на защищённой странице (например, после удаления аккаунта)
    if (response.status === 401 && !token && typeof window !== 'undefined' && window.location.pathname.includes('/profile')) {
      userLogout()
      window.location.href = '/'
      return null
    }

    if (response.status === 401 && token) {
      if (refreshPromise) {
        await refreshPromise
      } else {
        refreshPromise = getRefreshToken(token.refresh_token)
          .then((newTokens) => {
            refreshPromise = null
            return newTokens
          })
          .catch((err) => {
            refreshPromise = null
            throw err
          })

        const newTokens = await refreshPromise

        if (!newTokens || !newTokens.ok) {
          userLogout()
          if (typeof window !== 'undefined' && window.location.pathname.includes('/profile')) {
            window.location.href = '/'
          } else {
            window.location.reload()
          }
          return null
        }

        // Сохраняем новые токены
        setToken(newTokens)
        Cookies.set('token', newTokens.access_token, { path: '/' })
        token = newTokens
      }

      // Повторный запрос с новым токеном
      const updatedToken = JSON.parse(localStorage.getItem('user'))
      const retryHeaders = {
        ...headers,
        Authorization: `Bearer ${updatedToken.access_token}`,
      }

      const retryResponse = await fetch(`${domain}${endpoint}`, {
        method: init.method,
        body: init.body,
        headers: retryHeaders,
      })

      const retryData = await retryResponse.json()
      if (!retryResponse.ok) {
        // attach status for upstream error handling
        return Promise.reject({ ...retryData, status: retryResponse.status })
      }

      return Promise.resolve(retryData)
    }

    const data = await response.json()

    if (!response.ok) {
      // attach status for upstream error handling
      return Promise.reject({ ...data, status: response.status })
    }

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const upload = async (url, options) => {
  const formData = new FormData()

  formData.append('file', options?.file)

  if (options?.type) formData.append('type', options.type)

  return request(url, {
    body: formData,
    headers: new Headers(),
    method: options?.method || METHOD.POST,
  })
}

export const download = async (endpoint, options) => {
  const headers = options?.headers ?? initHeaders

  const token = getToken()

  if (token) {
    if (isExpired(token.expires_date)) {
      const response = await getRefreshToken(token.refresh_token)
      if (response.ok) {
        setToken(response)

        return await request(endpoint, options)
      } else {
        userLogout()
        window.location.reload()

        return
      }
    } else {
      headers['Authorization'] = `Bearer ${token.access_token}`
    }
  }

  const init = {
    body: options?.body,
    method: options?.method || METHOD.GET,
    headers,
  }

  const domain = options?.api ? options.api : API_BASE

  try {
    const response = await fetch(`${domain}${endpoint}`, init)

    if (response.status === 401) {
      userLogout()

      return
    }

    const data = await response.blob()

    if (!response.ok) {
      return Promise.reject(data)
    }

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}
